export default class Graph {
  constructor() {
    this.clearCode();
  }

  clearCode() {
    this.code = 'graph TD\n';
  }

  addNode(id, label) {
    this.code += this.getNodeCode(id, label);
  }

  removeNode(id, label) {
    this.code = this.code.replace(this.getNodeCode(id, label), '');
  }

  addEdge(nodeIdA, nodeIdB) {
    this.code += `${nodeIdA} --- ${nodeIdB}\n`;
  }

  nodeHasEdge(nodeId) {
    return this.code.includes(`--- ${nodeId}`) ||
           this.code.includes(`${nodeId} ---`);
  }

  getNodeCode(id, label) {
    return `${id}("${this.adjustLabel(label)}")\n`;
  }

  getCode() {
    return this.code;
  }

  adjustLabel(label) {
    if (label.includes('"')) {
      label = label.replace(/"/g, '\'');
    }
    return this.breakLine(label);
  }

  breakLine(text) {
    let words = [];
    const MAX_CHARS = 20;
    let brokenText = '';
    let charsLength = 0;

    if (text.includes('<br>')) {
      return text;
    }

    words = text.split(' ');

    words.forEach(word => {
      charsLength += word.length;

      brokenText += `${word} `;

      if (charsLength >= MAX_CHARS) {
        brokenText += '<br>';
        charsLength = 0;
      }
    });

    return brokenText;
  }

}



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/graph.js
 **/